import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ArrowUpIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 18 18"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.085 5.076C9.056 5.07 9.03 5.063 9 5.063c-.03 0-.056.007-.085.013-.028.005-.056.01-.083.02-.028.013-.052.032-.078.05-.019.013-.04.02-.058.036-.005.005-.007.012-.013.018-.005.006-.011.008-.017.014L2.65 12.146a.489.489 0 0 0 .03.668c.184.176.47.162.637-.031L9 6.235l5.684 6.548a.436.436 0 0 0 .637.03.481.481 0 0 0 .148-.348.482.482 0 0 0-.118-.319L9.334 5.214c-.006-.006-.012-.008-.018-.015-.005-.005-.007-.012-.012-.017-.018-.016-.039-.023-.058-.036-.026-.018-.05-.037-.078-.05-.027-.01-.054-.015-.083-.02Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default ArrowUpIcon;
